"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _button = _interopRequireDefault(require("../../../atoms/button"));

var _buttonGroup = _interopRequireDefault(require("../../button-group"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  margin-top: 32px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledActions = _styledComponents["default"].div(_templateObject());

var Actions = function Actions(props) {
  var primary = props.primary,
      clear = props.clear,
      secondary = props.secondary,
      reset = props.reset,
      submitting = props.submitting,
      handleSubmit = props.handleSubmit;
  return _react["default"].createElement(StyledActions, null, _react["default"].createElement(_buttonGroup["default"], {
    align: "right"
  }, secondary && secondary.map(function (action, index) {
    return _react["default"].createElement(_button["default"], {
      key: index,
      view: "link",
      icon: action.icon,
      onClick: action.handler
    }, action.label);
  }), clear && _react["default"].createElement(_button["default"], {
    view: "default",
    icon: clear.icon,
    onClick: reset
  }, clear.label), primary && _react["default"].createElement(_button["default"], {
    view: "primary",
    icon: primary.icon,
    onClick: handleSubmit
  }, primary.label)));
};

Actions.displayName = 'Form Actions';
Actions.propTypes = {};
Actions.defaultProps = {};
var _default = Actions;
exports["default"] = _default;